import styled from 'styled-components';
import {
  Badge, Text, TextArea, Button, TextField,
} from '@usealloy/component-library';

export const StyledBadge = styled(Badge)<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: var(--cl-radius-3);
  font-family: var(--cl-font-family-default);
  margin-right: var(--cl-space-1);
  padding: var(--cl-space-4);
`;

export const StyledHyperlinkText = styled(Text)`
  color: var(--cl-juicyBlue-500);
`;

export const StyledTextArea = styled(TextArea)<{ isRegexEditor: boolean }>`
    &&& {
      border: none;
      box-shadow: none;
    }
    color: ${({ isRegexEditor }) => (isRegexEditor ? 'var(--cl-pink-600)' : 'black')};
    font-family: var(--cl-font-family-mono);
    font-weight: ${({ isRegexEditor }) => (isRegexEditor ? 'normal' : 'bold')};
    padding-left: 0;
`;

export const StyledEditorButton = styled(Button)`
  font-family: var(--cl-font-family-default);
  margin: var(--cl-space-1);
`;

export const StyledTextField = styled(TextField)<{ isPreview?: boolean }>`
  &&& {
    margin: 0;
    opacity: ${props => (props.isPreview ? '0.5' : '1')};
    border: none;
    border-radius: 0;
    font-family: var(--cl-font-family-mono);
    font-size: var(--cl-font-size-2);
    font-weight: var(--cl-font-weight-bold);
    padding: 0px 3px;
    caret-color: var(--cl-yellow-500);
    background: transparent;
    color: var(--cl-text-default);
    height: fit-content;
    line-height: var(--cl-line-height-3);
    width: auto;
    min-width: 2ch;
    max-width: 100%;
    field-sizing: content;

    &:focus {
      outline: none;
      background-color: var(--cl-yellow-100);
      border: none;
      box-shadow: none;
      border-radius: var(--cl-radius-1);
    }

    &:hover {
      background-color: var(--cl-yellow-100);
    }
  }
`;

